//import toast from './toast';
export default class Profile {
    constructor() {
        this.edits = document.querySelectorAll('.edit');
        this.saves = document.querySelectorAll('.save');
        this.cancels = document.querySelectorAll('.cancel');
        this.emailPassword = document.querySelector('.email-password');
        this.emailLabels = document.querySelectorAll('.email-change-label');
        this.oldPassword = document.querySelector('.old-password');
        this.confirmPassword = document.querySelector('.confirm-password');
        this.resetLabels = document.querySelectorAll('.password-reset-label');
        this.inputs = document.querySelectorAll('.form-control');
        this.container = document.querySelector('.profile');

        if (this.container) {
            let success = this.container.getAttribute('data-success');

            if (success === 'True') {
                //toast.success('Profile updated');
            }
        }

        this.addListeners();
    }

    addListeners() {
        if (this.edits.length) {
            this.edits.forEach(t => {
                t.addEventListener('click', e => {
                    this.edit(e)
                });
            });
        }

        if (this.cancels.length) {
            this.cancels.forEach(c => {
                c.addEventListener('click', e => {
                    this.cancel(e)
                });
            });
        }
    }

    edit(e) {
        e.preventDefault();
        const target = e.target;
        const editor = target.parentElement.previousElementSibling;
        if (editor.classList.contains('reset-password-edit')) {
            let children = editor.children;

            if (this.oldPassword) {
                this.oldPassword.style.display = 'block';
            }

            if (this.confirmPassword) {
                this.confirmPassword.style.display = 'block';
            }

            if (this.resetLabels.length) {
                this.resetLabels.forEach(r => {
                    r.style.display = 'block';
                })
            }

            for (let i = 0; i < children.length; i++) {
                children[i].classList.add('editing');
            }
        } else if (editor.classList.contains('email-change-edit')) {
            let children = editor.children;

            if (this.emailPassword) {
                this.emailPassword.style.display = 'block';
            }

            if (this.emailLabels.length) {
                this.emailLabels.forEach(e => {
                    e.style.display = 'block';
                })
            }

            for (let i = 0; i < children.length; i++) {
                children[i].classList.add('editing');
            }
        }
        else {
            editor.classList.add('editing');
        }
         

        if (this.inputs.length) {
            this.inputs.forEach(input => {
                if (input.classList.contains('editing')) {
                    //hide edit button
                    let closestEdit = target.closest('.edit');
                    closestEdit.style.display = 'none';

                    //show save and cancel buttons
                    let closestSave = closestEdit.nextElementSibling;
                    let closestCancel = closestSave.nextElementSibling;
                    closestSave.style.display = 'block';
                    closestCancel.style.display = 'block';
                }
            });
        }
    }

    cancel(e) {
        e.preventDefault();
        const target = e.target;
        //hide save and cancel buttons
        target.style.display = 'none';
        let siblingSave = target.previousElementSibling;
        siblingSave.style.display = 'none';

        if (this.oldPassword) {
            this.oldPassword.style.display = 'none';
        }

        if (this.confirmPassword) {
            this.confirmPassword.style.display = 'none';
        }

        if (this.resetLabels.length) {
            this.resetLabels.forEach(r => {
                r.style.display = 'none';
            })
        }

        //remove editing class
        if (this.inputs.length) {
            this.inputs.forEach(input => {
                if (input.classList.contains('editing')) {
                    input.classList.remove('editing');

                    //cancel input change -- return old value
                    let originalValue = input.defaultValue;

                    if (input.value != originalValue) {
                        input.value = originalValue;
                    }
                }
            });
        }

        //show edit button
        let closestEdit = siblingSave.previousElementSibling;
        closestEdit.style.display = 'block';
    }
}